<app-grading-period-selector (selectionEvent)="viewUnits($event)">
</app-grading-period-selector>
